import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleDownSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronTriangleDownSmall"><Path d="M7 10L12 16.6667L17 10H7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleDownSmall;
